<div class="l-row">
  <div class="l-col--side l-col--sideNavigation l-col--sideLeft"></div>
  <div class="l-col--main">
    <div class="c-article">
      <h1 class="c-article__title">Luomun tarina tietosuojaseloste</h1>
      <div class="c-article__body">
        <p>Päivitetty 23.11.2020</p>
        <h2>1. Yleist&auml;</h2>
        <p>
          Tervetuloa Luomun tarina-verkkokauppaan! Seulo Palvelut Oy (jäljempänä
          ”Yritys”, ”me” tai ”meidän”) on sitoutunut huolehtimaan yksityisyyden
          suojastasi. Otamme yksityisyyden suojan vakavasti ja haluamme, että
          tunnet olosi turvalliseksi vieraillessasi ja asioidessasi
          verkkokaupassamme. Tässä tietosuojaselosteessa informoimme muun muassa
          siitä, mitä tietojasi keräämme, mihin tarkoituksiin käytämme niitä,
          kuinka kauan säilytämme tietojasi sekä mitkä ovat tietolainsäädännön
          mukaiset oikeutesi ja miten voit niitä käyttää.
        </p>
        <p>
          Tämä tietosuojaseloste koskee sinua, jos olet verkkokauppamme asiakas
          tai muutoin vierailet verkkokauppamme verkkosivuilla. Katsomme, että
          olet asiakkaamme, mikäli olet luonut itsellesi käyttäjätunnuksen
          kauppaamme.
        </p>
        <p>
          Verkkosivuillamme voi olla linkkejä kolmansien osapuolien
          ylläpitämille sivustoille. Emme ole vastuussa näiden kolmansien
          osapuolien sivustoista eikä tietosuojaselosteemme koske kyseisiä
          sivustoja. Mikäli siirryt verkkosivujemme kautta kolmansien osapuolien
          ylläpitämille sivustoille, suosittelemme, että tutustut kyseisten
          sivustojen omiin käyttöehtoihin ja tietosuojaselosteisiin.
        </p>
        <h2>2. Rekisterinpitäjä ja yhteyshenkilö</h2>
        <p><strong>Rekisterinpitäjä</strong></p>
        <p>
          Seulo Palvelut Oy ("Yritys")<br />
          Y-tunnus: 2231096-6
        </p>

        <p>
          <strong> Rekisterinpitäjän yhteyshenkilö / yhteystaho </strong>
        </p>
        <p>
          Linni Heino <br />
          linni.heino@kauppahalli24.fi.
        </p>
        <p>&nbsp;</p>
        <h2>3. Miten ja mitä tietoja keräämme</h2>
        <p>
          Tässä kerromme miten ja mitä tietojasi keräämme vieraillessasi
          verkkosivuillamme tai asioidessasi verkkokaupassamme.
        </p>
        <h3>3.1 Tiedot, jotka keräämme, kun vierailet verkkosivuillamme</h3>
        <p>
          Kun tulet verkkosivuillemme, esimerkiksi tutustuaksesi toimintaamme
          mutta et vielä luo asiakastunnusta, keräämme sinusta seuraavia
          tietoja:
        </p>
        <ul>
          <li>Päätelaitteen tunnistetiedot</li>
          <li>Yhteyttä koskevat tiedot</li>
          <li>Verkkosivumme käyttö- ja selaustiedot</li>
        </ul>
        <p>
          Edellä mainittujen tietojen kerääminen on pakollista, jotta pystymme
          takaamaan verkkosivumme toimivuuden sekä sen turvallisuuden. Keräämme
          nämä tiedot automaattisesti vieraillessasi verkkosivullamme.
        </p>
        <h3>3.2 Tiedot, jotka keräämme, kun luot asiakastunnuksen</h3>
        <p>
          Luodessasi itsellesi asiakastunnuksen pääset tekemään tilauksia
          verkkokaupassamme. Tilin luomista varten sinun tulisi antaa seuraavia
          itseäsi koskevia tietoja:
        </p>
        <ul>
          <li>Etunimi, sukunimi</li>
          <li>Kirjautumistiedot (sähköpostiosoite ja salasana)</li>
          <li>Yhteystiedot</li>
          <li>Puhelin numero</li>
          <li>Lupa sms-viestien lähettämiseen</li>
          <li>Lupa uutiskirjeen lähettämiselle</li>
          <li>Toimitusosoitetiedot</li>
          <li>Yrityksen nimi, y-tunnus</li>
        </ul>
        <p>
          Lisäksi keräämme jo mainittuja verkkosivujen toimivuuteen sekä
          turvallisuuteen tarvittavia tietoja:
        </p>
        <ul>
          <li>Päätelaitteen tunnistetiedot</li>
          <li>Yhteyttä koskevat tiedot</li>
          <li>Verkkosivumme käyttö- ja selaustiedot</li>
        </ul>
        <h3>3.3 Tiedot, jotka keräämme, kun teet tilauksia</h3>
        <p>
          Tehdessäsi tilauksia tarvitsemme luonnollisesti tietoja, jotta voimme
          käsitellä tilauksesi sekä toimittaa tilaamasi tuotteet. Tehdessäsi
          tilauksia keräämme seuraavia tietoja:
        </p>
        <ul>
          <li>
            asiakastunnuksen tiedot (etunimi, sukunimi, yrityksen nimi,
            yhteystiedot, toimitusosoitteentiedot)
          </li>
          <li>Toimitusajankohtaan liittyvät tiedot</li>
          <li>Tilaus- ja tuotetiedot</li>
          <li>Maksutiedot</li>
          <li>Toimitukseen liittyvät tiedot</li>
        </ul>
        <p>
          Lisäksi keräämme jo mainittuja verkkosivujen toimivuuteen sekä
          turvallisuuteen tarvittavia tietoja:
        </p>
        <ul>
          <li>Päätelaitteen tunnistetiedot</li>
          <li>Yhteyttä koskevat tiedot</li>
          <li>Verkkosivumme käyttö- ja selaustiedot</li>
        </ul>
        <h3>3.4 Muut tilanteet, joissa keräämme tietojasi</h3>
        <p>
          Keräämme tietojasi myös, jotta pystymme tarjoamaan sinulle parempaa ja
          henkilökohtaisempaa palvelua sekä tuottaaksemme sinulle
          merkityksellisempää sisältöä ja suositellaksemme mielestämme sinulle
          parhaiten sopivia tuotteita. Seuraavassa on kuvattu muut tilanteet,
          joissa keräämme tietojasi:
        </p>
        <ul>
          <li>
            Mikäli sinulla tulee kysyttävää esimerkiksi verkkokaupan käytöstä
            tai tilauksiisi liittyen, voit ottaa yhteyttä asiakaspalveluumme
            soittamalla tai sähköpostilla. Keräämme siis tietojasi, kun asioit
            asiakaspalvelumme kanssa.
          </li>
          <li>
            Kun asioit verkkokaupassamme ja reagoit uutiskirjeisiimme keräämme
            myös tietoa, jota hyödynnämme analytiikan avulla paremman palvelun
            tarjoamiseksi. Käyttämällä analytiikkaa pystymme:
          </li>
          <ul>
            <li>
              selaus- ja tilaustiedoistasi päättelemään sinulle sopivimpia
              tuotesuosituksia
            </li>
            <li>
              tilaustiedoistasi ja siitä, miten reagoit uutiskirjeisiimme
              päättelemään sinua kiinnostavat ruoka-aiheet ja reseptit.
            </li>
          </ul>
        </ul>
        <h2>
          4. Henkilötietojen käyttötarkoitukset ja käsittelyn oikeusperusteet
        </h2>
        <p>
          Keräämme tietojasi silloin, kun se on tarpeellista ja henkilötietojen
          käyttötarkoitus on määritetty. Seuraavassa taulukossa informoimme
          siitä, mikä on keräämiemme tietojen käyttötarkoitus sekä mitkä ovat
          henkilötietojesi käsittelyn oikeusperusteet.
        </p>
        <div class="c-tableContainer">
          <table>
            <colgroup>
              <col style="width: 30%" />
              <col style="width: 30%" />
              <col style="width: 40%" />
            </colgroup>
            <thead>
              <tr>
                <td><strong> Käyttötarkoitus</strong></td>
                <td><strong> Käsittelyn oikeusperuste </strong></td>
                <td><strong> Lisätietoja </strong></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Asiakastunnuksen ylläpitäminen.</td>
                <td>Yrityksen oikeutettu etu.</td>
                <td>
                  Oikeutettu etumme perustuu meidän ja sinun väliseen
                  asiakassuhteeseen. Uskomme, että asiakastunnuksen avulla
                  pystymme tarjoamaan sinulle parhaan mahdollisen
                  asiakaskokemuksen.
                </td>
              </tr>
              <tr>
                <td>Tilausten käsitteleminen ja niiden toimittaminen.</td>
                <td>Yrityksen ja sinun välinen sopimus.</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>Asiakaspalvelun toteuttaminen ja parantaminen.</td>
                <td>
                  Yrityksen ja sinun välinen sopimus sekä Yrityksen oikeutettu
                  etu.
                </td>
                <td>
                  Oikeutettu etumme perustuu asiakaspalvelun ja
                  asiakaskokemuksen kehittämiseen. Pyrimmekin jatkuvasti
                  kehittämään asiakaspalveluamme, jotta saat parhaan mahdollisen
                  kokemuksen asioidessasi kanssamme.
                </td>
              </tr>
              <tr>
                <td>
                  Verkkokaupan kehittäminen ja henkilökohtaisemman sisällön
                  tarjoaminen.
                </td>
                <td>Yrityksen oikeutettu etu.</td>
                <td>
                  Oikeutettu etumme perustuu meidän ja sinun väliseen
                  asiakassuhteeseen. Haluamme kehittää verkkokauppaamme juuri
                  sinulle sopivammaksi ja siksi uskomme, että
                  henkilökohtaisemman sisällön tuottaminen ja verkkokaupan
                  kehittäminen on sekä meidän että myös sinun etusi.
                </td>
              </tr>
              <tr>
                <td>Kohdennetun markkinoinnin toteuttaminen.</td>
                <td>Yrityksen oikeutettu etu.</td>
                <td>
                  Oikeutettu etumme perustuu meidän ja sinun väliseen
                  asiakassuhteeseen. Pyrimme kohdistamaan sinulle mahdollisimman
                  kiinnostavaa ja merkityksellistä markkinointia tuotteistamme
                  ja tarjouksistamme.
                  <br />
                  Mikäli et kuitenkaan halua vastaanottaa markkinointia voit
                  ilmoittaa siitä ottamalla yhteyttä asiakaspalveluumme. Jos et
                  myöskään halua vastaanottaa uutiskirjeitämme voit peruuttaa
                  niiden tilauksen uutiskirjesähköpostin lopussa olevan linkin
                  kautta.
                </td>
              </tr>
              <tr>
                <td>
                  Turvallisuuden varmistaminen ja verkkokaupan suojaaminen.
                </td>
                <td>
                  Yrityksen lakisääteinen velvollisuus sekä Yrityksen oikeutettu
                  etu.
                </td>
                <td>
                  Olemme lain nojalla velvoitettuja suojaamaan tietojasi
                  asianmukaisesti.
                  <br />
                  Oikeutettu etumme perustuu kaupallisten intressiemme
                  suojaamiseen.
                </td>
              </tr>
              <tr>
                <td>Telemarkkinointi</td>
                <td>Yrityksen oikeutettu etu</td>
                <td>
                  Oikeutettu etumme perustuu meidän ja sinun väliseen
                  asiakassuhteeseen. Asiakastunnuksen luomisen yhteydessä itse
                  antamiasi tietoja voidaan käyttää
                  telemarkkinointitarkoituksiin. Voit kieltää tietojesi käytön
                  telemarkkinointia varten ilmoittamalla siitä
                  asiakaspalveluumme.
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p>&nbsp;</p>
        <h2>5. Kuinka kauan säilytämme tietoja</h2>
        <p>
          Säilytämme tietojasi tarvittavan ajan, jotta pystymme toteuttamaan
          tässä tietosuojaselosteessa mainitut käyttötarkoitukset. Mikäli
          toteamme, että asiakassuhteemme on muuttunut epäaktiiviseksi,
          poistamme tietosi sekä asiakastunnuksesi viimeistään 3 vuoden kuluttua
          aktiivisuuden päättymisestä. Joitain tietoja voimme joutua
          säilyttämään kauemmin, jos laki meitä siihen edellyttää.
        </p>
        <h2>6. Kenelle jaamme tietoja</h2>
        <p>
          Emme koskaan jaa tietojasi kolmansille osapuolille, joilla ei ole
          oikeutta saada tietojasi. Tässä tietosuojaselosteessa määriteltyjen
          käyttötarkoitusten toteuttamiseksi käytämme kuitenkin
          palveluntarjoajia, joille siirrämme tietojasi. Huolehdimme siitä, että
          palveluntarjoajille siirtämämme tiedot ovat rajoitettu vain
          käyttötarkoituksen kannalta tarpeellisiin tietoihin. Varmistamme myös
          sopimusjärjestelyin, että käyttämämme palveluntarjoajat käsittelevät
          tietojasi tietosuojalainsäädännön edellyttämällä tavalla ja muutoinkin
          tässä tietosuojaselosteessa esitetyllä tavalla.
        </p>
        <p>Jaamme tietojasi seuraaville tietojen vastaanottajille:</p>

        <div class="c-tableContainer">
          <table>
            <colgroup>
              <col style="width: 40%" />
              <col style="width: 60%" />
            </colgroup>
            <thead>
              <tr>
                <td><strong>Tiedon vastaanottaja</strong></td>
                <td><strong> Syy </strong></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Ulkoiset palveluntarjoajat</td>
                <td>
                  Ulkoiset palveluntarjoajat tukevat liiketoimintaamme ja
                  mahdollistavat palvelumme laadun sekä turvallisuuden. Käytämme
                  seuraavia ulkoisia palveluntarjoajia: ohjelmistopalvelut,
                  markkinointipalvelut, push-ilmoitukset, kuljetuspalvelut,
                  tekstiviestinvälityspalvelut, analytiikkapalvelut,
                  tuotesuosituspalvelut, asiakaspalvelu ja IT- ja
                  ohjelmistotukipalvelut.
                </td>
              </tr>
              <tr>
                <td>Viranomaiset tai tuomioistuimet</td>
                <td>
                  Jos tietojesi luovuttaminen on tarpeellista
                  viranomaistarkoituksiin tai lainsäädännön noudattamiseksi.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <h2>7. Tietojen siirto EU:n tai Euroopan talousalueen ulkopuolelle</h2>
        <p>
          Käsittelemme tietojasi pääasiassa EU:n sisällä. Tosin, osa
          käyttämistämme palveluntarjoajista sijaitsee – tai käsittelee tietoja
          EU:n ja Euroopan talousalueen ulkopuolella. Varmistamme, että palvelun
          tarjoajamme, jotka sijaitsevat tai käsittelevät tietojasi EU:n tai
          Euroopan talousalueen ulkopuolella ovat sitoutuneet turvaamaan tietosi
          tietosuojalainsäädännön edellyttämällä tavalla. Olemme varmistaneet,
          että tietojasi suojataan siitä huolimatta, että niitä voi siirtyä EU:n
          ja Euroopan talousalueen ulkopuolelle seuraavilla tavoilla:
        </p>
        <ul>
          <li>
            Tietoja vastaanottava palveluntarjoaja on hyväksytty EU:n ja
            Yhdysvaltojen välisen Privacy Shield – sopimuksen mukaisen
            sertifiointimekanismin alla noudattamaan Privacy Shield-sopimuksen
            vaatimuksia tietosuojan riittävästä tasosta;
          </li>
          <li>
            Tietoja vastaanottavalla palveluntarjoajalla on EU:n jäsenvaltion
            tietosuojaviranomaisen hyväksymät konsernia sitovat
            tietosuojasäännökset; tai
          </li>
          <li>
            Olemme sitoneet tietoja siirtävän palveluntarjoajan noudattamaan
            Euroopan komission laatimia vakiosopimuslausekkeita, joiden avulla
            varmistetaan tietosuojan riittävä taso.
          </li>
        </ul>
        <p>
          Halutessasi voit pyytää lisätietoja tietojen siirrosta EU:n tai
          Euroopan talousalueen ulkopuolelle ottamalla yhteyttä tässä
          tietosuojaselosteessa mainittuun yhteyshenkilöön.
        </p>
        <h2>8. Profilointi</h2>
        <p>
          Voimme käsitellä tietojasi hyödyntämällä profilointia. Profiloinnin
          avulla analysoimme:
        </p>
        <ul>
          <li>Miten olet käyttänyt verkkosivujamme</li>
          <li>Mistä tuotteista ja tarjouksista olet ollut kiinnostunut</li>
          <li>Mihin uutiskirjeistämme olet reagoinut</li>
          <li>Mitä tuotteita olet tilannut.</li>
        </ul>
        <p>
          Profiloinnin avulla varmistamme, että saat parempaa ja
          henkilökohtaisempaa sisältöä sekä sopivampia tarjouksia, joiden
          uskomme sinua kiinnostavan.
        </p>
        <p>
          Voit vastustaa profilointia henkilökohtaiseen erityiseen tilanteeseesi
          liittyvällä perusteella. Profiloinnin vastustamiseksi voit olla
          yhteydessä tässä tietosuojaselosteessa mainittuun yhteystahoon.
        </p>
        <h2>9. Oikeutesi</h2>
        <p>Sinulla on seuraavat oikeudet tietosuojalainsäädännön mukaisesti:</p>
        <h3>9.1 Oikeus saada pääsy tietoihin (oikeus tarkistaa tiedot)</h3>
        <p>
          Sinulla on oikeus tarkistaa, mitä sinua koskevia tietoja on
          tallennettu sekä saada kopio tiedoista. Voit milloin tahansa
          tarkastella omia tietojasi asiakastunnuksesi kautta. Tämän lisäksi
          voit pyytää yhteenvedon omista tiedoistasi asiakaspalvelusta.
        </p>
        <h3>
          9.2 Oikeus tietojen korjaamiseen ja tietojen käsittelyn rajoittamiseen
        </h3>
        <p>
          Voit itse korjata omia tietojasi asiakastunnuksesi avulla. Sitoudumme
          kuitenkin korjaamaan virheelliset tai epätäydelliset tiedot mikäli et
          itse pysty sitä tekemään. Tällaisessa tilanteessa ota yhteyttä
          asiakaspalveluumme.
        </p>
        <p>
          Tietojen käsittelyn rajoittaminen tarkoittaa, että tietoa tai tietoja
          ei pyynnöstäsi käsitellä, vaikka ne silti säilytetään (ns.
          passiivitilassa) Yrityksen toimesta. Sinulla on oikeus lain nojalla
          rajoittaa tietojesi käsittelyä, jos tiedot ovat mielestäsi
          virheellisiä. Rajoittamisen aikana selvitetään tietojen
          paikkansapitävyys. Sinulla on myös oikeus vaatia tietojesi
          säilyttämistä rajoitettuna, jos tietoja on käsitelty viranomaisen
          määräyksen mukaan lainvastaisesti ja et halua tietojasi poistettavan.
          Jos haluat rajoittaa tietojesi käsittelyä ota yhteyttä tässä
          tietosuojaselosteessa määriteltyyn yhteystahoon.
        </p>
        <h3>9.3 Oikeus tietojen poistamiseen</h3>
        <p>
          Voit tilata tietojesi poistamisen asiakaspalvelusta, jos niin haluat.
          Huomioi kuitenkin, että emme välttämättä pysty poistamaan tiettyjä
          tietoja silloin, kun laki vaatii meitä niitä säilyttämään tai jos
          joudumme säilyttämään tietojasi oman oikeusturvamme varmistamiseksi.
        </p>
        <h3>9.4 Oikeus vastustaa tietojen käsittelyä</h3>
        <p>
          Voit milloin tahansa vastustaa tietojen käsittelyä markkinointi
          tarkoituksiin ilmoittamalla siitä asiakaspalveluumme.
        </p>
        <h3>9.5 Oikeus siirtää tiedot järjestelmästä toiseen</h3>
        <p>
          Sinulla on oikeus saada itseäsi koskevat tiedot yleisesti käytössä
          olevassa siirtomuodossa. Sinulla on oikeus saada tiedot vain niiltä
          osin, kun tietojasi käsitellään sopimuksen perusteella. Voit pyytää
          asiakastietosi asiakaspalvelusta. Lähetämme asiakastietosi sinulle
          csv- siirtomuodossa.
        </p>
        <h3>9.6 Oikeus tehdä valitus valvontaviranomaiselle</h3>
        <p>
          Jos katsot, että oikeuksiasi on rikottu voit tehdä asiasta valituksen
          tietosuojaviranomaiselle EU:n alueella. Suomessa valvovana
          viranomaisena toimii Tietosuojavaltuutetun toimisto.
          Tietosuojavaltuutetun toimiston yhteystiedot löydät osoitteesta
          www.tietosuoja.fi.
        </p>
        <h2>10. Tietojen suojauksen periaatteet</h2>
        <p>
          Yrityksen asiakastiedot sijaitsevat suojatuissa tietokannoissa, jotka
          ovat palomuurein, salasanoin ja muiden teknisten ja organisatoristen
          keinojen avulla suojattuja. Yrityksen järjestelmien sekä tietokantojen
          tietoturva ovat korkealla tasolla ja ne ovat suojattuja tietomurtoja
          vastaan. Järjestelmiin ja tietokantoihin pääsy on rajoitettu vain
          sellaisille työntekijöillemme, joilla on työtehtäviensä perusteella
          tarve käyttää tietoja. Lisäksi jokainen tietojasi käsittelevä
          työntekijämme tai ulkoinen palveluntarjoaja on sitoutunut
          asianmukaiseen salassapitoon. Tietojen käsittelyn oikeellisuutta ja
          tämän tietosuojaselosteen mukaista tietojen käsittelyä seurataan myös
          lokitiedostojen avulla.
        </p>
        <p>
          Asiakkaana sinun tulee myös huolehtia siitä, että tietosuoja- ja
          tietoturvariskit minimoidaan. Näin ollen muista, että käyttäjätunnus
          ja salasana ovat henkilökohtaisia. Älä luovuta salasanaasi
          ulkopuolisille ja pyri käyttämään mahdollisimman vahvaa salasanaa.
        </p>
        <h2>11. Evästeet ja push-ilmoitukset</h2>
        <p>
          Asiakkaan päätelaitteelle voidaan toimittaa evästeitä (”cookies”).
          Eväste on pieni tekstitiedosto, jonka avulla voidaan kerätä tietoja
          siitä, miten Verkkokauppaa käytetään, eli esimerkiksi milloin ja mitä
          Verkkokaupan sivuja Asiakas on selannut, mistä Asiakas on tullut
          Verkkokauppaan ja mitä selainta Asiakas käyttää. Evästeiden avulla
          saatu tieto on luonteeltaan anonyymiä, mutta evästeen avulla saatua
          tietoa on mahdollista liittää Asiakkaalta saatuihin henkilötietoihin.
        </p>
        <p>
          Evästeiden käytön tarkoituksena on analysoida ja kehittää
          Verkkokauppaa, jotta Yritys voi palvella Asiakkaitaan entistä
          paremmin, sekä hyödyntää tietoja Verkkokaupan kävijämäärien
          tilastollisessa seurannassa ja erilaisessa Verkkokaupan toimintojen
          tehon mittauksessa. Evästeiden avulla kerättyä tietoa voidaan käyttää
          myös kohdennetun mainonnan tuottamiseen (myös ns. Retargeting).
        </p>
        <p>
          Retargeting-mainonnassa myös muilla verkkosivustoilla voi näkyä
          tuotteita, jotka liittyvät Asiakkaan käyttäytymiseen Verkkokaupassa.
          Yritys ei luovuta kerättyä tietoa kolmansien osapuolien
          markkinointikäyttöön. Asiakkaalla on mahdollisuus kytkeä evästeiden
          käyttö pois selainasetuksistaan tai poistamalla evästeet
          Verkkokaupassa asioinnin jälkeen, mutta tällä on vaikutusta
          Verkkokaupan käyttömahdollisuuksiin sitä heikentävästi tai jopa sen
          kokonaan estäen.
        </p>
        <p>
          Verkkokauppa hyödyntää Google Analyticsia, joka on Google Inc:n
          analysointityökalu. Sivustolla vierailustanne havainnoituja tietoja
          säilytetään Google Analytics -analytiikkapalvelun erillisessä
          tietokannassa. Google Analytics käyttää siis tekstitiedoston muodossa
          olevia evästeitä parantaakseen verkkosivun käytön analysointia. Google
          voi myös välittää tietoja kolmansille osapuolille, jos lainsäädäntö
          edellyttää sitä tai jos kolmas osapuoli käsittelee tietoja Googlen
          puolesta. IP-osoitettasi ei yhdistetä muihin tietoihin, joita
          Googlella voi olla sinusta.
        </p>

        <h3>11.1 Evästeiden käyttötarkoitukset</h3>

        <div class="c-tableContainer">
          <table>
            <colgroup>
              <col style="width: 25%" />
              <col style="width: 25%" />
              <col style="width: 25%" />
              <col style="width: 25%" />
            </colgroup>
            <thead>
              <tr>
                <td><strong> Palvelun nimi </strong></td>
                <td><strong> Käyttötarkoitus </strong></td>
                <td><strong> Tietojen säilytysaika </strong></td>
                <td><strong> Kuvaus </strong></td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Giosg</td>
                <td>perustoiminnallisuus</td>
                <td>2 v</td>
                <td>Sivustolle "upotettu" chat- keskustelupalvelu</td>
              </tr>
              <tr>
                <td>Google Tag Manager</td>
                <td>statistiikka</td>
                <td>2 v</td>
                <td>
                  Työkalu sivustoon upotettujen Javascript koodien
                  hallinnointiin.
                </td>
              </tr>
              <tr>
                <td>Google Analytics</td>
                <td>statistiikka</td>
                <td>2 v</td>
                <td>Kävijäseuranta ja analysointi</td>
              </tr>
              <tr>
                <td>Insider</td>
                <td>personoitu sisältö</td>
                <td>7 kk</td>
                <td>Web push integraatio. Kytketty TAG managerin avulla</td>
              </tr>
              <tr>
                <td>Facebook pixel</td>
                <td>Kohdistettu markkinointi</td>
                <td>3 kk</td>
                <td>Facebook toiminnallisuuksien kävijäseuranta</td>
              </tr>
              <tr>
                <td>Adform</td>
                <td>Kohdistettu markkinointi</td>
                <td>2 kk</td>
                <td></td>
              </tr>
              <tr>
                <td>Apsis one</td>
                <td>Uutiskirje</td>
                <td>2 v</td>
                <td>Uutiskirjeen tilaaminen</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2>12. Muutokset tietosuojaselosteeseen</h2>
        <p>
          Pyrimme kehittämään palveluitamme jatkuvasti ja tarjoamaan paremman
          asiakaskokemuksen sinulle. Tämän myötä joitakin palveluita ja
          toiminnallisuuksia saattaa tulla lisää tai ne voivat muuttua, jolloin
          päivitämme tätä tietosuojaselostetta tarpeen mukaan. Lainsäädännön
          muutokset saattavat myös asettaa tarpeita muuttaa tai tarkentaa tämän
          tietosuojaselosteen osia.
        </p>
      </div>
    </div>
  </div>
  <div class="l-col--side l-col--sideNavigation l-col--sideRight"></div>
</div>
